import React from 'react';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import {
	useAnalyticsEvents,
	fireOperationalAnalytics,
} from '@atlassian/jira-product-analytics-bridge';

const LazyComponent = lazyForPaint(() =>
	import(
		/* webpackChunkName: "async-galileo-experiment-auto-create-first-jsm-project-modal" */ './index'
	).then((mod) => mod.AutoCreateFirstJsmProjectModal),
);

const Component = ({ projectKey }: { projectKey: string }) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	return (
		<JSErrorBoundary
			id="lazy-recommend-templates-in-project-menu"
			packageName="jiraExperiments"
			fallback="unmount"
			onError={() =>
				fireOperationalAnalytics(
					createAnalyticsEvent({}),
					'lazyForPaint errored',
					'lazy-recommend-templates-in-project-menu',
				)
			}
		>
			<LazySuspense fallback={null}>
				<LazyComponent projectKey={projectKey} />
			</LazySuspense>
		</JSErrorBoundary>
	);
};

export default Component;
